/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    PostSearchDataItemQueryOrderProperty,
    PostSearchDataItemQueryOrderPropertyFromJSON,
    PostSearchDataItemQueryOrderPropertyFromJSONTyped,
    PostSearchDataItemQueryOrderPropertyToJSON,
} from './';

/**
 * 
 * @export
 * @interface PostSearchDataItemQuery
 */
export interface PostSearchDataItemQuery {
    /**
     * 
     * @type {string}
     * @memberof PostSearchDataItemQuery
     */
    correlationId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PostSearchDataItemQuery
     */
    providerId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PostSearchDataItemQuery
     */
    route?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PostSearchDataItemQuery
     */
    routeIsCityCode?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PostSearchDataItemQuery
     */
    flightNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PostSearchDataItemQuery
     */
    fareBasisPattern?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PostSearchDataItemQuery
     */
    excluded?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof PostSearchDataItemQuery
     */
    stepName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PostSearchDataItemQuery
     */
    ticketingCarrier?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PostSearchDataItemQuery
     */
    _class?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PostSearchDataItemQuery
     */
    fareType?: string | null;
    /**
     * 
     * @type {PostSearchDataItemQueryOrderProperty}
     * @memberof PostSearchDataItemQuery
     */
    orderProperty?: PostSearchDataItemQueryOrderProperty;
    /**
     * 
     * @type {boolean}
     * @memberof PostSearchDataItemQuery
     */
    orderAsc?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof PostSearchDataItemQuery
     */
    offset?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PostSearchDataItemQuery
     */
    limit?: number | null;
}

export function PostSearchDataItemQueryFromJSON(json: any): PostSearchDataItemQuery {
    return PostSearchDataItemQueryFromJSONTyped(json, false);
}

export function PostSearchDataItemQueryFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostSearchDataItemQuery {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'correlationId': !exists(json, 'correlationId') ? undefined : json['correlationId'],
        'providerId': !exists(json, 'providerId') ? undefined : json['providerId'],
        'route': !exists(json, 'route') ? undefined : json['route'],
        'routeIsCityCode': !exists(json, 'routeIsCityCode') ? undefined : json['routeIsCityCode'],
        'flightNumber': !exists(json, 'flightNumber') ? undefined : json['flightNumber'],
        'fareBasisPattern': !exists(json, 'fareBasisPattern') ? undefined : json['fareBasisPattern'],
        'excluded': !exists(json, 'excluded') ? undefined : json['excluded'],
        'stepName': !exists(json, 'stepName') ? undefined : json['stepName'],
        'ticketingCarrier': !exists(json, 'ticketingCarrier') ? undefined : json['ticketingCarrier'],
        '_class': !exists(json, 'class') ? undefined : json['class'],
        'fareType': !exists(json, 'fareType') ? undefined : json['fareType'],
        'orderProperty': !exists(json, 'orderProperty') ? undefined : PostSearchDataItemQueryOrderPropertyFromJSON(json['orderProperty']),
        'orderAsc': !exists(json, 'orderAsc') ? undefined : json['orderAsc'],
        'offset': !exists(json, 'offset') ? undefined : json['offset'],
        'limit': !exists(json, 'limit') ? undefined : json['limit'],
    };
}

export function PostSearchDataItemQueryToJSON(value?: PostSearchDataItemQuery | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'correlationId': value.correlationId,
        'providerId': value.providerId,
        'route': value.route,
        'routeIsCityCode': value.routeIsCityCode,
        'flightNumber': value.flightNumber,
        'fareBasisPattern': value.fareBasisPattern,
        'excluded': value.excluded,
        'stepName': value.stepName,
        'ticketingCarrier': value.ticketingCarrier,
        'class': value._class,
        'fareType': value.fareType,
        'orderProperty': PostSearchDataItemQueryOrderPropertyToJSON(value.orderProperty),
        'orderAsc': value.orderAsc,
        'offset': value.offset,
        'limit': value.limit,
    };
}


